import type { JSX } from 'react'

/**
 * Câu chữ của bản cũ có `<b>…</b>` bên trong — dựng thành phần tử React, KHÔNG nhét HTML thô.
 *
 * ⭐ TÁCH RA DÙNG CHUNG ngày 18/09/2026. Hàm này vốn nằm riêng trong `approvals/RequestPosting.tsx`,
 * nên `vendor-portal/ReportTab.tsx` gọi thẳng `t()` cho một chuỗi CÓ thẻ và **in ra nguyên văn**
 * `chuyến của <b>Nhà cung cấp mẫu</b> … ở tab <b>Đối soát cước</b>` — lỗi lộ ra NGOÀI công ty, và
 * lộ ở cả ba thứ tiếng (`locales/{vi,en,zh}/ncc.json`).
 *
 * ⚠ KHÔNG dùng `dangerouslySetInnerHTML`: chuỗi dịch có thể chứa tên đối tác do người dùng nhập.
 *   Cách tách này chỉ hiểu đúng `<b>`, mọi thứ khác giữ nguyên dạng chữ.
 */
export const rich = (text: string): (string | JSX.Element)[] =>
  text.split(/<b>(.*?)<\/b>/g).map((part, i) => (i % 2 === 1 ? <b key={i}>{part}</b> : part))
